<script>
/* eslint-disable camelcase */
import {
  get_naver_token
} from '../../ETC/Axios'

export default {
  name: 'NaverLogin',
  mounted () {
    const code = new URL(window.location.href).searchParams.get('code')

    get_naver_token(code).then((check_data) => {
      if (check_data.customer_join_level === 1) {
        window.location.href = `/Join?customer_ID=${check_data.customer_ID}&customer_name=${check_data.customer_name}&customer_email=${check_data.customer_email}`
      } else {
        alert('로그인이 완료되었습니다.')
        this.$router.push('/')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/NaverLogin.vue